import { clearDialogAudio, getAudioPeaks, getDialogAudio, selectDialogAudio } from "@/store/ses/sesArchiveSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useAccessRight } from "@/hooks";
import { SES } from "@/constants/accessRights";
import { RequestStatus, ResponseStatus } from "@/types/statusTypes";
import { BlockWithError, BlockWithLoading } from "@/ui";
import AudioPlayer from "../../AudioPlayer/AudioPlayer";
import { IAudioDataProps } from "./AudioData.props";
import styles from "./AudioData.module.scss";

const AudioData = ({ selectedDialogue }: IAudioDataProps): JSX.Element => {
	const isAccess = useAccessRight(); // hook для проверки прав доступа

	const dispatch = useAppDispatch();
	const dialogAudio = useAppSelector(selectDialogAudio); // store - аудио диалога

	const getAudio = (): void => {
		dispatch(clearDialogAudio()); // очистка аудио диалога
		isAccess(SES.ARCHIVE_WAVEFORM) && dispatch(getAudioPeaks(selectedDialogue.uuid)); // получение пиков аудио-файла
		isAccess(SES.ARCHIVE_AUDIO) && dispatch(getDialogAudio(selectedDialogue.uuid)); // получение аудио диалога для голосового канала
	};

	return (
		<>
			{/* загрузка */}
			{(dialogAudio.status === RequestStatus.LOADING || dialogAudio.audioPeakStatus === RequestStatus.LOADING) && <BlockWithLoading inLine />}

			{/* ошибка */}
			{(dialogAudio.status === RequestStatus.FAILED || dialogAudio.error === ResponseStatus.FAILED) && dialogAudio.audioPeakStatus !== RequestStatus.LOADING && (
				<BlockWithError message={dialogAudio.message === "dialog not found" ? "title_dialogNotFound" : dialogAudio.message} updateHandler={getAudio} />
			)}

			{dialogAudio.status === RequestStatus.IDLE && dialogAudio.audioPeakStatus !== RequestStatus.LOADING && dialogAudio.dataUrl && (
				<div className={styles.audio}>
					<AudioPlayer
						url={dialogAudio.dataUrl}
						timeline
						timestamp={dialogAudio.timestamp}
						sendTimestamp="dialogueArchive"
						playbackSpeed
						peaks={dialogAudio.audioPeaks.length > 0 ? dialogAudio.audioPeaks : undefined}
						audioFormat="opus"
					/>
				</div>
			)}
		</>
	);
};

export default AudioData;
